import React from 'react'
import { Controller, Control, UseControllerProps } from 'react-hook-form'
import { Input, InputProps } from '@surecompanies/core_components'
import { Stack, TextColors, Typography } from '@sureco/design-system'

type RHFInputProps = Omit<InputProps, 'name'> & {
  name: string
  control: Control<any, object> // unable to make it work using generics yet Control<T>
  rules?: UseControllerProps['rules']
  label?: string
}
export default function RHFInput({
  name,
  control,
  rules,
  label,
  ...rest
}: RHFInputProps) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => {
        return (
          <Stack space={2}>
            {label && <Typography>{label}</Typography>}
            <Input
              name={field.name}
              status={fieldState.error ? 'error' : undefined}
              onBlur={field.onBlur}
              value={field.value}
              onChange={(event) => {
                field.onChange(event)
              }}
              ref={field.ref}
              {...rest}
            />
            {fieldState.error && (
              <Typography color={TextColors.error}>
                {fieldState.error.message}
              </Typography>
            )}
          </Stack>
        )
      }}
    />
  )
}
